module.exports = __webpack_public_path__ + "img/profit-icon1.3fdb7523.png";